import { Outlet } from "react-router";
import { Toaster } from "@/components/ui/sonner"
const MainLayout = () => {
  return (
    <div className="w-full h-full flex flex-col items-center justify-center">
      <Outlet />
      <Toaster />
    </div>
  );
};

export default MainLayout;
